import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, Check, Loader2, Star } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Membership() {
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/membership/plans").then((r) => setPlans(r.data.plans)).catch(() => {}); }, []);

  const subscribe = async (plan) => {
    if (plan === "Free") { toast.info("You're already a free fan!"); return; }
    if (!user) { toast.error("Sign in to become a member"); return; }
    setBusy(plan);
    try { const { data } = await api.post("/membership/checkout", { plan, origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not start checkout"); setBusy(""); }
  };

  return (
    <div className="section py-12 sm:py-16" data-testid="membership-page">
      <p className="kicker mb-2">Join the Inner Circle</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">Fan Memberships</h1>
      <p className="mt-3 max-w-xl text-amber-100/60">Go beyond the vote. Unlock exclusive content, early access and premium livestreams.</p>
      {user && <p className="mt-2 text-sm text-gold">Your plan: {user.membership || "Free"}</p>}

      <div className="mt-10 grid gap-5 lg:grid-cols-3">
        {plans.map((p) => {
          const featured = p.key === "member_premium";
          return (
            <div key={p.key} className={`card-lux relative p-7 ${featured ? "ring-1 ring-gold" : ""}`} data-testid={`plan-${p.key}`}>
              {featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 gold-bg text-obsidian text-[0.6rem] font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1"><Star className="h-3 w-3" /> Most Popular</span>}
              <Crown className={`h-7 w-7 ${p.key === "member_vip" ? "text-gold" : "text-gold/60"}`} />
              <h3 className="mt-3 font-serif text-2xl text-amber-50">{p.name}</h3>
              <p className="mt-1 font-mono text-3xl gold-text">{p.price}</p>
              <ul className="mt-5 space-y-2">
                {p.features.map((f) => <li key={f} className="flex items-center gap-2 text-sm text-amber-100/70"><Check className="h-4 w-4 text-emerald-accent shrink-0" /> {f}</li>)}
              </ul>
              <button onClick={() => subscribe(p.key)} disabled={busy === p.key} data-testid={`subscribe-${p.key}`}
                className={`mt-6 w-full inline-flex items-center justify-center gap-2 ${p.key === "Free" ? "btn-ghost-gold" : "btn-gold"}`}>
                {busy === p.key && <Loader2 className="h-4 w-4 animate-spin" />} {p.key === "Free" ? "Current Plan" : "Subscribe"}
              </button>
            </div>
          );
        })}
      </div>
      <p className="mt-6 text-xs text-muted-foreground">Billed monthly via Stripe. Test card 4242 4242 4242 4242. Cancel anytime.</p>
    </div>
  );
}
